import 'material-design-icons-iconfont/dist/material-design-icons.css';
import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: 'mdi'
    },
    theme: {
        themes: {
            primary: '#000000',
            accent: '#ffffff',
            secondary: '#FFE18D',
            success: '#4CAF50',
            info: '#365D7B',
            warning: '#A61F3D',
            error: '#FE011B'
        }
    }
});
